<template>
  <el-dialog
      :title="'Lịch sử thay đổi điểm danh'"
      :visible.sync="showHistoryUpdateAttendance"
      width="40%"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      top="30vh"
      @open="handleOpen"
  >
    <el-table
        ref="multipleTable"
        highlight-current-row
        :empty-text="textTable"
        :data="responseList"
        :header-cell-style="tableHeaderColor"
        :max-height="$tableMaxHeight"
        border
    >
      <el-table-column
          type="index"
          label="STT"
          width="50"
          align="center"
      ></el-table-column>
      <el-table-column prop="createdDate" label="Ngày thao tác" width="150" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.createdDate | formatDateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="actorName" label="Tên người thao tác" min-width="200">
      </el-table-column>
      <el-table-column prop="action" label="Thao tác" width="200">
        <template slot-scope="scope">
          <span v-if="scope.row.action ==='CREATE'">Tạo điểm danh</span>
          <span v-if="scope.row.action ==='DELETE'">Xóa điểm danh</span>
          <span v-if="scope.row.action ==='UPDATE'">Cập nhật điểm danh</span>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button type="danger" size="medium" @click="closeDialog()">
        <i class="el-icon-circle-close" />
        <span>Đóng</span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>

import shiftMaster from "@/services/ShiftMaster";

export default {
  props: {
    showHistoryUpdateAttendance: {
      type: Boolean,
      default: () => false,
    },
    recordId: {
      type: [String, Number],
      default: () => null,
    }
  },
  data() {
    return {
      textTable: this.$tableLoading,
      idClass: "",
      idGroup: "",
      className: "",
      responseList: [],
      loadingButton: false,
      checkAll: false,
      type: ""
    };
  },
  methods: {
    name: "HistoryUpdateAttendanceDialog",
    handleOpen(){
      shiftMaster.searchHistoryUpdateAttendance(this.recordId).then(response => {
        this.responseList = response.data.data;
        console.log(this.responseList);
      }).catch(error => {
        console.log(error);
      })
    },
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;";
    },
    //reset when click x
    closeDialog() {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.loadingButton = false;
        this.responseList = [];
        this.checkAll = false;
      }, 300);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__title {
  font-size: 25px;
  color: #606266;
}
/deep/.el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}
/deep/.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-left: -4px;
}
/deep/.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
}
</style>
